import styled from 'styled-components';

export const AlreadyLoggedInPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 0.5rem;
`;
